import Cookies from 'js-cookie';
export default function ({ $axios }) {
    $axios.onRequest(config => {
        const token = Cookies.get('auth_token'); // 쿠키에서 토큰 읽기
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    });
}
